import React, { useEffect, useState } from "react";
import BottomNavigationBar from "./BottomNavigation";
import SessionTimer from "./SessionTimer";

import { makePostRequest } from "../API";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import moment from "moment";
import {
  setCountry,
  setCountryList,
  setTransportList,
  setTravelType,
  setSectors,
  setActualTransportData,
} from "../Store/Slices/countrySlice";
//import countUp
import "./Dashboard.css";

import DashboardCard from "./reuseableComponents/DashboardCard";
import NotArrangeCard from "./reuseableComponents/NotArrangeCard";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const Navigate = useNavigate();
  const data = useSelector((state) => state.Country.dashboardData);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint = "api/umrah/dashboard";

        const response = await makePostRequest(endpoint);

        if (response?.message === "Token expired") {
          localStorage.removeItem("token");
          localStorage.removeItem("RememberMe");

          message.error("Token expired Log In Again");
          return Navigate("/login");
        }

        setDashboardData(response.data);

        const countries = await makePostRequest("api/world/countries");

        if (!countries) return;
        const contryList = countries.data.map((country) => {
          return [country.ISO2, country.Name];
        });
        dispatch(setCountryList(contryList));
        const transport = await makePostRequest("api/transport");
        const transportList = transport.data.map((transport) => {
          return [transport.Name, transport.UID];
        });

        dispatch(setTransportList(transportList));

        const travelType = await makePostRequest("api/travel");
        dispatch(setTravelType(Object.entries(travelType.data)));

        const sectors = await makePostRequest("api/transport/sector");
        const sectorsList = sectors.data.map((sector) => {
          return [sector.Name, sector.UID];
        });
        dispatch(setSectors(sectorsList));
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const [DashboardName, setDashboardName] = useState("");

  useEffect(() => {
    // Retrieve data from local storage when the component mounts
    const savedData = localStorage.getItem("UserName");
    if (savedData) {
      setDashboardName(JSON.parse(savedData));
    }
  }, []);

  const dateFormat = "YYYY-MM-DD";
  // const todayDate = moment(new Date()).format(dateFormat);
  const Yesterday = moment().subtract(1, "day").format(dateFormat);

  // consoles
  // console.log("DashboardName>>>>>>>>>>>>", DashboardName);
  // console.log("Dashboard data fetched", dashboardData);
  // console.log("Dashbarod data from redux store is :", data);


  return (
    <>
      {/* <SessionTimer expirationDuration={13000000} /> */}

      <div
        className="p-4 background-img page-font"
        style={{ minHeight: "100vh" }}
      >
        <nav style={{ height: "10vh" }}>
          <div className="heading-bg"></div>
          <div className="dashboard-main-heading">
            <h1 className="heading-wrapper">Welcome {DashboardName}!</h1>
          </div>
        </nav>
        {/* detail */}
        <div>
          <h1
            className="bg-light p-4 text-center"
            style={{ marginTop: "50px" }}
          >
            Hotels Arrangement
          </h1>
          <div className="row">
            <NotArrangeCard
              dashboardData={dashboardData}
              link={"/not-arrange"}
              second={dashboardData?.allow_transport}
              heading={"Not Arranged"}
              // day={"Today"}
              bgcolor={"#DC4C64"}
            />
          </div>
          <div className="row">
            <DashboardCard
              dashboardData={dashboardData}
              link={"/allow-hotel-makkah"}
              second={dashboardData?.["allow-htl-mecca"]}
              heading={"Allow Hotel Makkah"}
              // day={"Today"}
              bgcolor={"#DEA527"}
              // bgcolor={"#14A44D"}
            />

            <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.["check-in-mecca"]}
              heading={"CheckIn Hotel Makkah"}
              link={"/checkin-makkah-hotel"}
              // day={"Today"}
              bgcolor={"#14A44D"}
            />
          </div>
          <div className="row">
            <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.["allow-htl-medina"]}
              heading={"Allow Hotel Madina"}
              link={"/allow-hotel-madina"}
              // day={Yesterday}
              bgcolor={"#DEA527"}
            />

            <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.["check-in-medina"]}
              heading={"CheckIn Hotel Madina"}
              // day={Yesterday}
              link={"/checkin-madina-hotel"}
              bgcolor={"#14A44D"}
            />
          </div>
        </div>

        <div>
          <h1
            className="bg-light p-4 text-center"
            style={{ marginTop: "50px" }}
          >
            Transport
          </h1>
          <div className="row">
            <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.["allow-tpt-mecca"]}
              heading={"Makkah TPT"}
              link={"/allow-makkah-tpt"}
              // day={"Today"}
              bgcolor={"#14A44D"}
            />

{/* actual transport card for makkah */}
               <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.allow_transport}
              heading={" Actual Makkah TPT"}
              link={"/actual-makkah-tpt"}
              // day={"Today"}
              bgcolor={"#DEA527"}
            /> 









          </div>

          <div className="row">

            <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.["allow-tpt-medina"]}
              heading={"Madina TPT"}
              // day={"Today"}
              link={"/allow-madina-tpt"}
              bgcolor={"#14A44D"}
            />


  <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.allow_transport}
              heading={" Actual Madina TPT"}
              link={"/actual-madina-tpt"}
              // day={"Today"}
              bgcolor={"#DEA527"}
            /> 
          </div>








          <div className="row">
            <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.["allow-tpt-jeddah"]}
              heading={"Jeddah TPT"}
              // day={Yesterday}
              link={"/allow-jeddah-tpt"}
              bgcolor={"#14A44D"}
            />


 <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.allow_transport}
              heading={" Actual Jeddah TPT"}
              link={"/actual-jeddah-tpt"}
              // day={"Today"}
              bgcolor={"#DEA527"}
            /> 







          </div>
            <DashboardCard
              dashboardData={dashboardData}
              second={dashboardData?.actual_transport}
              heading={"Arrival/Departure"}
              // day={Yesterday}
              bgcolor={"#14A44D"}
              link={"/arrival-departure-tpt"}
            />
        </div>

        <div style={{ marginTop: "50px" }}>
          <BottomNavigationBar />
        </div>
      </div>
    </>
  );
}

export default Dashboard;
